import { Box, TextField, Typography } from '@mui/material';
import SectionHeading from './SectionHeading';

export default function SimpleTextTab({
    title,
    field,
    encounter,
    onPatch,
    disabled,
    placeholder,
    rows = 6,
    hint,
}) {
    const value = encounter?.[field] || '';
    const charCount = value.length;
    return (
        <Box>
            <SectionHeading title={title} hint={hint} />
            <TextField
                fullWidth
                multiline
                rows={rows}
                value={value}
                onChange={(e) => onPatch({ [field]: e.target.value })}
                disabled={disabled}
                placeholder={placeholder}
                variant="outlined"
                InputProps={{
                    sx: {
                        fontSize: 14.5,
                        lineHeight: 1.55,
                        bgcolor: disabled ? 'action.hover' : '#fff',
                        '& fieldset': { borderColor: 'rgba(5,47,93,0.15)' },
                        '&:hover fieldset': { borderColor: 'rgba(5,47,93,0.35) !important' },
                        '&.Mui-focused fieldset': { borderColor: '#052F5D !important', borderWidth: 1 },
                    },
                }}
            />
            <Typography
                variant="caption"
                sx={{ color: 'text.disabled', mt: 0.5, display: 'block', textAlign: 'right' }}
            >
                {charCount} character{charCount === 1 ? '' : 's'}
            </Typography>
        </Box>
    );
}
